/**
 * 拥抱组件
 * zxw
 * 2024-01-17
 */

import { Row, Col } from 'antd';

const EmbraceAI = () => {
    return <>
        <div className='embrace-ai' style={{ padding: '40px 0', color: '#000', 
            fontSize: '18px',
        }}>
            <Row>
                <Col offset={2} span={20}>
                    <p><span style={{ fontSize: '40px' }}>拥抱数据，在AI中创造未来</span></p>
                </Col>
            </Row>
        </div>
    </>
}

export default EmbraceAI;